module.exports = __webpack_public_path__ + "static/media/bus_glif.452af31a.svg";